import * as en from '@/assets/svgs/en/GetReady.json'
import * as fr from '@/assets/svgs/fr/GetReady.json'
import * as tc from '@/assets/svgs/tc/GetReady.json'
import * as sc from '@/assets/svgs/sc/GetReady.json'

const GetReady = {
    "en": JSON.stringify(en),
    "fr": JSON.stringify(fr),
    "tc": JSON.stringify(tc),
    "sc": JSON.stringify(sc)
}

export default GetReady
